import { render } from "./SidebarQuadra.vue?vue&type=template&id=e0e7da00&scoped=true"
import script from "./SidebarQuadra.vue?vue&type=script&lang=js"
export * from "./SidebarQuadra.vue?vue&type=script&lang=js"

import "./SidebarQuadra.vue?vue&type=style&index=0&id=e0e7da00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0e7da00"]])

export default __exports__